import React from 'react'

const Disclaimer = () => {
    return (


        <div className="main_page_container">
            <div className="page_heading">
                <h1>Disclaimer</h1>
            </div>
            <div className="page_section">
                <ul>
                    <li> This disclaimer pertains to the use of our educational app ("the App"), which does not collect personal information. By accessing and using the App, you agree to comply with the terms and conditions outlined below. If you do not agree with any of these terms, please refrain from using the App.</li>
                    <li><strong>No Personal Information Collection: </strong>The App is designed to provide educational information and resources without collecting any personal information from its users. We do not require or solicit personal data such as names, email addresses, contact information, or any other personally identifiable information.

                    </li>

                    <li><strong>User Anonymity: </strong>The App operates on an anonymous basis, ensuring that your identity remains undisclosed while using the educational materials and resources provided. Any data or information generated by your use of the App is aggregated and anonymized for statistical purposes only.

                    </li>

                    <li><strong>Third-Party Links:</strong> The App may include links to external websites, applications, or resources provided by third parties. Please note that these third-party platforms may have their own privacy policies and data collection practices. We are not responsible for the content, privacy practices, or actions of these third parties. Users are encouraged to review the privacy policies of any linked platforms before engaging with their content.

                    </li>


                    <li><strong>Limitation of Liability:</strong> While we strive to provide accurate and reliable educational content, we do not warrant or guarantee the completeness, correctness, or timeliness of the information provided in the App. The educational materials are for general informational purposes only and should not be considered professional advice. We shall not be held liable for any damages or losses arising from the use of the App or reliance on its content.

                    </li>


                    <li><strong>User Responsibility: </strong>Users are responsible for their own actions and usage of the App. It is important to use the educational materials in a responsible and lawful manner. Any unauthorized use, dissemination, or modification of the App's content is strictly prohibited. Users shall indemnify and hold us harmless from any claims, damages, or liabilities arising out of their use of the App.

                    </li>
                    <li>
                        <strong>Modifications: </strong>We reserve the right to modify, suspend, or discontinue the App or any part thereof, at any time and without prior notice. We may also update this disclaimer from time to time, and it is the user's responsibility to review it periodically for any changes.
                    </li>
                    <li>By using the App, you acknowledge and agree to release, indemnify, and hold us harmless from any and all claims, damages, losses, liabilities, costs, and expenses (including legal fees) arising from your use of the App or any violation of this disclaimer.</li>
                    <li>If you have any questions or concerns regarding this disclaimer, please contact us through the provided channels.</li>

                </ul>
            </div>

        </div>

    )
}

export default Disclaimer